module.exports = __webpack_public_path__ + "static/media/cazoleta.21307257.png";